export const LOCAL_DEMO_COMPANY_ID = "local-demo-company";
export const LOCAL_DEMO_PROFILE_ID = "local-demo-profile";
export const LOCAL_DEMO_PROJECT_ID = "local-demo-project";

const LOCAL_DEMO_KEY = "uppgerd-local-demo";

export const isLocalDemoAvailable = () => (
  typeof window !== "undefined" &&
  ["localhost", "127.0.0.1"].includes(window.location.hostname)
);

export const isLocalDemoEnabled = () => (
  isLocalDemoAvailable() && window.localStorage.getItem(LOCAL_DEMO_KEY) === "true"
);

export const enableLocalDemo = () => {
  if (!isLocalDemoAvailable()) return;
  window.localStorage.setItem(LOCAL_DEMO_KEY, "true");
  window.localStorage.setItem("timetrack-current-role", "employee");
};
